import React from "react"
import { StyledIcon } from "../StyledIcon"

// eslint-disable-next-line import/prefer-default-export
const ChatWithUsWmoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M8.70322 1.90716L8.33406 1.90615C7.35346 1.90363 6.38446 2.13314 5.50768 2.576C4.46103 3.0991 3.5786 3.90516 2.96172 4.90268C2.34483 5.90019 2.01785 7.04976 2.0174 8.22261L2.02512 8.54901C2.06305 9.30907 2.24012 10.0566 2.54752 10.7537L2.56773 10.7982L1.38409 14.3506L1.36085 14.4399C1.27167 14.9134 1.72802 15.3322 2.20627 15.1728L5.75873 13.9882L5.50769 13.8698C6.38436 14.3126 7.35332 14.542 8.33569 14.5396C9.50728 14.539 10.6568 14.212 11.6542 13.5952C12.6517 12.9783 13.4578 12.0959 13.9822 11.0468C14.4238 10.1724 14.6533 9.20344 14.6508 8.22117V7.88952C14.5642 6.30437 13.9103 4.84101 12.8132 3.74382C11.7159 2.6466 10.2525 1.99265 8.70322 1.90716ZM8.33238 3.20617L8.63159 3.20518C9.86139 3.27305 11.023 3.79213 11.8939 4.66305C12.7648 5.53395 13.2838 6.69553 13.3517 7.92535L13.3508 8.22286C13.3528 9.00206 13.1711 9.76909 12.8205 10.4631C12.4029 11.2988 11.7627 11.9996 10.9705 12.4895C10.1783 12.9794 9.26533 13.2391 8.33375 13.2396C7.55474 13.2415 6.7877 13.0599 6.09378 12.7094L5.99831 12.6703C5.8679 12.6287 5.72672 12.6291 5.59519 12.6729L3.02773 13.5282L3.88405 10.9617C3.93885 10.7973 3.92573 10.6178 3.84759 10.4631C3.49703 9.7691 3.31537 9.00209 3.3174 8.22456C3.31776 7.29164 3.57744 6.37866 4.06737 5.58644C4.5573 4.79422 5.25812 4.15404 6.09132 3.73762C6.78782 3.38582 7.55484 3.20416 8.33238 3.20617Z"
      fill="#3E3E47"
    />
  </svg>
)

export default ChatWithUsWmoIcon
